import { forwardRef, type ButtonHTMLAttributes } from 'react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger';
  /** Stato di caricamento: disabilita e annuncia "in corso". */
  loading?: boolean;
  loadingText?: string;
}

const variantClasses: Record<NonNullable<ButtonProps['variant']>, string> = {
  primary:
    'bg-panda-700 text-white hover:bg-panda-800 active:scale-[0.98] dark:bg-panda-600 dark:hover:bg-panda-500',
  secondary:
    'border-2 border-panda-700 text-panda-700 hover:bg-panda-50 active:scale-[0.98] dark:border-panda-400 dark:text-panda-300 dark:hover:bg-ink-800',
  danger: 'bg-danger text-white hover:opacity-90 active:scale-[0.98]',
};

/**
 * Bottone con feedback immediato al press (apple-design §1: response on pointer-down
 * via :active) e stato di caricamento annunciato agli screen reader.
 */
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'primary', loading = false, loadingText = 'Operazione in corso…', disabled, children, className, type = 'button', ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={`inline-flex items-center justify-center gap-2 rounded-xl px-5 py-2.5 text-base font-semibold transition-[transform,background-color] duration-100 disabled:cursor-not-allowed disabled:opacity-60 ${variantClasses[variant]} ${className ?? ''}`}
      {...props}
    >
      {loading ? loadingText : children}
    </button>
  );
});
